module.exports = __webpack_public_path__ + "static/media/sadhan.0c9d7ba0.jpg";